function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var getTaskProgressStyle = function getTaskProgressStyle(prefixCls, token) {
  var _$concat;
  return _defineProperty({}, ".".concat(prefixCls), (_$concat = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_$concat, ".taskProgressContainer", _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: '22px',
    padding: '16px',
    overflow: 'hidden',
    backgroundColor: '#fff'
  }, ".timeline", {
    position: 'absolute',
    left: '32px',
    top: '30px',
    bottom: '16px',
    zIndex: 0,
    width: '1px',
    backgroundColor: '#ECEEF5'
  }), ".nodeView", _defineProperty(_defineProperty({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px'
  }, ".icon", _defineProperty({
    width: '34px',
    height: '34px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff'
  }, ".circleDot", {
    display: 'inline-block',
    width: '9px',
    height: '9px',
    borderRadius: '50%',
    backgroundColor: '#336DFF'
  })), ".titleRow", _defineProperty({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  }, ".titleText", {
    color: '#0d1121',
    fontSize: '16px',
    fontWeight: 500
  }))), ".titleView", _defineProperty(_defineProperty({
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
    overflow: 'hidden'
  }, ".icon", {
    width: '34px',
    height: '34px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }), ".taskProgressContent", _defineProperty({
    flex: 1,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    gap: '4px'
  }, ".row", {
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
  }))), ".text", {
    color: '#6e707a',
    fontSize: '12px',
    lineHeight: '16px'
  }), ".logView", _defineProperty({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column'
  }, ".logTitleRow", _defineProperty(_defineProperty(_defineProperty(_defineProperty({
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  }, ".text", {
    color: '#0d1121',
    fontSize: '12px',
    fontWeight: 600
  }), ".pointView", _defineProperty({
    width: '34px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0
  }, ".point", {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: '#6e707a'
  })), ".titleContent", {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  }), ".row", {
    display: 'flex',
    alignItems: 'center',
    gap: '6px'
  })))), ".taskProgressContent1", _defineProperty({
    marginLeft: '44px'
  }, "& > div", _defineProperty(_defineProperty({}, "&:first-child", {
    marginTop: '12px'
  }), "&:last-child", {
    paddingBottom: '0'
  }))), ".userList", {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '8px'
  }), ".userItem", _defineProperty(_defineProperty(_defineProperty(_defineProperty({
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    overflow: 'hidden',
    height: '28px',
    borderRadius: '28px',
    padding: '1px',
    paddingRight: '8px',
    backgroundColor: '#f4f6fc',
    boxSizing: 'border-box',
    cursor: 'pointer'
  }, "&:active", {
    opacity: 0.8
  }), ".userAvatar", {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1px',
    backgroundColor: '#6bb1d7',
    height: '26px',
    width: '26px',
    borderRadius: '26px',
    boxSizing: 'border-box',
    overflow: 'hidden'
  }), ".minText", {
    color: '#fff',
    textShadow: '0 1.023px 2.045px rgba(12, 62, 154, 0.36)',
    fontSize: '10px',
    fontWeight: 500,
    whiteSpace: 'nowrap',
    wordWrap: 'break-word',
    wordBreak: 'break-all'
  }), ".fullText", {
    color: '#3d414d',
    fontSize: '13px'
  })), ".titleText", {
    color: '#0d1121',
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '22px'
  }), ".text", {
    color: '#0d1121',
    fontSize: '14px'
  }), ".textBlack", {
    color: '#0d1121',
    fontSize: '14px'
  }), ".textDanger", {
    color: '#fa8c16',
    fontSize: '12px'
  }), ".statusText", {
    color: '#606266',
    fontSize: '13px',
    fontWeight: 500,
    padding: '1px 6px',
    display: 'inline-block',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '2px'
  }), ".timeText", {
    color: '#9ea0a6',
    fontSize: '11px'
  }), _defineProperty(_$concat, ".whiteBg", {
    backgroundColor: '#fff'
  })));
};